import { Home01Icon } from '@hugeicons/core-free-icons';
import { createIcon } from '../icon';

export const Home = /* @__PURE__ */ createIcon(Home01Icon, 'Home');
